import React from "react";
import { IconProps } from "./IconProps";

const ArrowUpIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.2806 11.0306C19.211 11.1004 19.1282 11.1557 19.0372 11.1934C18.9461 11.2312 18.8486 11.2506 18.75 11.2506C18.6514 11.2506 18.5538 11.2312 18.4628 11.1934C18.3717 11.1557 18.289 11.1004 18.2194 11.0306L12.75 5.56031V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V5.56031L5.78061 11.0306C5.63988 11.1714 5.44901 11.2504 5.24999 11.2504C5.05097 11.2504 4.8601 11.1714 4.71936 11.0306C4.57863 10.8899 4.49957 10.699 4.49957 10.5C4.49957 10.301 4.57863 10.1101 4.71936 9.96937L11.4694 3.21937C11.539 3.14964 11.6217 3.09432 11.7128 3.05658C11.8038 3.01883 11.9014 2.9994 12 2.9994C12.0986 2.9994 12.1961 3.01883 12.2872 3.05658C12.3782 3.09432 12.461 3.14964 12.5306 3.21937L19.2806 9.96937C19.3503 10.039 19.4057 10.1217 19.4434 10.2128C19.4812 10.3038 19.5006 10.4014 19.5006 10.5C19.5006 10.5986 19.4812 10.6962 19.4434 10.7872C19.4057 10.8782 19.3503 10.961 19.2806 11.0306Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowUpIcon;
